export enum AuthAction {
  ChangePassword = 'change-password',
  ConfirmLogin = 'confirm-login',
  EnterLogin = 'enter-login',
  ResetPassword = 'reset-password',
  SignIn = 'sign-in',
  SignUp = 'sign-up',
  TinkoffIdCompleteAuthFlow = 'tinkoff-id-complete-auth-flow',
  YandexIdCompleteAuthFlow = 'yandex-id-complete-auth-flow'
}

const {
  ChangePassword,
  ConfirmLogin,
  EnterLogin,
  SignIn,
  SignUp,
  ResetPassword
} = AuthAction

const nameMapping = new Map([
  [ChangePassword, 'Изменение пароля'],
  [ConfirmLogin, 'Подтверждение логина'],
  [ResetPassword, 'Сброс пароля'],
  [EnterLogin, 'Вход и регистрация'],
  [SignIn, 'Вход по паролю'],
  [SignUp, 'Регистрация почты'],
])

export const AuthActionUtils = {
  getName: (x: AuthAction): string => nameMapping.get(x)!
}
